import { CARD_PATTERNS } from './cardConstants';

/**
 * Detecta o tipo do cartão baseado no número - Baseado no AddCardModal
 */
export const detectCardType = (cardNumber) => {
  const cleanNumber = cardNumber.replace(/\D/g, '');
  
  for (const [flag, pattern] of Object.entries(CARD_PATTERNS)) {
    if (pattern.test(cleanNumber)) {
      return flag;
    }
  }
  return null;
};

/**
 * Valida CPF/CNPJ/NIF - Baseado no AddCardModal
 */
export const validateDocumentNumber = (value) => {
  const cleanValue = value.replace(/\D/g, '');
  return cleanValue.length >= 11; // Validação básica
};

/**
 * Valida número do cartão - Baseado no AddCardModal
 */
export const validateCardNumber = (value) => {
  const cleanValue = value.replace(/\D/g, '');
  return cleanValue.length >= 13 && cleanValue.length <= 19;
};

/**
 * Valida data de expiração - Baseado no AddCardModal
 */
export const validateExpiry = (month, year) => {
  if (!month || !year || month.length < 2 || year.length < 4) {
    return false;
  }
  
  const monthNum = parseInt(month);
  const yearNum = parseInt(year);
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  
  if (monthNum < 1 || monthNum > 12) return false;
  if (yearNum < currentYear) return false;
  if (yearNum > currentYear + 20) return false;
  if (yearNum === currentYear && monthNum < currentMonth) return false;
  
  return true;
};

/**
 * Valida CVV - Baseado no AddCardModal
 */
export const validateCVV = (value) => {
  const cleanValue = value.replace(/\D/g, '');
  return cleanValue.length >= 3 && cleanValue.length <= 4;
};